import type { RouterLocation } from '../reducers/router'
import { ROUTER_LOCATION_CHANGE } from '../reducers/router'

export interface LocationChangeAction {
  type: typeof ROUTER_LOCATION_CHANGE
  payload: {
    location: RouterLocation
    action: string
  }
}

export const locationChange = (
  location: RouterLocation,
  action: string = 'PUSH',
): LocationChangeAction => ({
  type: ROUTER_LOCATION_CHANGE,
  payload: {
    location,
    action,
  },
})
